module.exports = __webpack_public_path__ + "static/img/unit4.6356d23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unit4.png
// module id = aEGT
// module chunks = 1